import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box } from '@mui/material';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Layout, Loading, Navbar, ReturnButton } from '../../../../components';
import * as RetailProfileActions from '../../../../core/retail-profiles/action';
import { VENDOR_NAVBAR_MENU, VENUE_NAVBAR_MENU } from '../../../../constants/navbar';
import AboutRetailSpace from './components/AboutRetailSpace';
import AvailableSchedules from './components/AvailableSchedules';
import ApplyButton from './components/ApplyButton';
import Map from './components/Map';

export default function RetailOpportunityDetails() {
  const [title] = useState('Retail Space Details');
  const { profileId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { user } = useSelector((store) => store.users);
  const { profileDetails: currentProfile, loading } = useSelector((store) => store.retailProfiles);

  useEffect(() => {
    // Fetch retail profile with venue and schedules
    dispatch(RetailProfileActions.getRetailProfileById(profileId));
  }, [dispatch, profileId]);

  if (loading) {
    return (
      <Layout>
        <Loading />
        <Navbar
          elements={user?.role?.name === 'Fayven-Vendor' ? VENDOR_NAVBAR_MENU : VENUE_NAVBAR_MENU}
        />
      </Layout>
    );
  }

  if (!currentProfile) {
    return (
      <Layout>
        <Navbar
          elements={user?.role?.name === 'Fayven-Vendor' ? VENDOR_NAVBAR_MENU : VENUE_NAVBAR_MENU}
        />
        <Grid container justifyContent="center" marginTop={15}>
          <Typography variant="h5" color="text.secondary">
            Retail space not found
          </Typography>
        </Grid>
      </Layout>
    );
  }

  return (
    <Layout>
      {loading && <Loading />}
      <Navbar
        elements={user?.role?.name === 'Fayven-Vendor' ? VENDOR_NAVBAR_MENU : VENUE_NAVBAR_MENU}
      />

      <Grid container justifyContent="space-evenly">
        <Typography variant="h4" fontWeight="bold" marginTop={9}>
          {title}
        </Typography>
      </Grid>

      <Grid container justifyContent="flex-start" marginTop={2}>
        <Grid item md={2} marginLeft={{ md: 20 }}>
          <ReturnButton />
        </Grid>
      </Grid>

      <Grid container justifyContent="center" marginTop={2}>
        <Grid item xs={12} md={10}>
          <Typography variant="h6" paddingX={4} textAlign="center">
            Explore this retail opportunity and reserve your spot at this venue!
          </Typography>
        </Grid>
      </Grid>

      <Grid container marginTop={5} justifyContent="center">
        <Grid
          item
          sm={11}
          backgroundColor="#e2bcaf2e"
          borderRadius="45px"
          paddingX={{ xs: 5, md: 5, xl: 20 }}
          paddingBottom={3}
          marginBottom={3}
          marginX={{ xs: 1, xl: 20 }}
          justifyContent="space-evenly">
          <div>
            <Typography
              variant="h5"
              color="#EE7B57"
              marginTop={4}
              textAlign="center"
              fontWeight="bold"
              style={{ textTransform: 'uppercase' }}>
              {currentProfile?.venue?.name}
            </Typography>
            <Typography variant="subtitle1" textAlign="center" color="text.secondary" marginTop={1}>
              Retail Space Opportunity
            </Typography>
          </div>

          <Grid container justifyContent="space-between" marginTop={3}>
            <Grid item xs={12} display="flex" justifyContent="center">
              <Box maxWidth="800px" width="100%">
                <AboutRetailSpace profile={currentProfile} venue={currentProfile?.venue} />
              </Box>
            </Grid>

            <Grid container marginY={3}>
              <AvailableSchedules schedules={currentProfile?.schedules} />
            </Grid>

            {user?.role?.name === 'Fayven-Vendor' && (
              <Grid container marginY={3} justifyContent="center">
                <Grid item xs={12} sm={8} md={6}>
                  <ApplyButton profile={currentProfile} />
                </Grid>
              </Grid>
            )}

            <Grid container marginY={3}>
              <Map city={currentProfile?.venue?.city} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}
